import * as constants from "../constants";
export const buildContent = (content) => {
    const { heading, switchToMobile, actionsTxt } = constants;
    return content ? content : `${heading}${switchToMobile}${actionsTxt}`;
};
//sb-ui-message is placing the wrapper class on the wrong element. Should be fixed in 4.3, because the impact is too big!
/* istanbul ignore next */
export const addCustomClass = () => {
    const popUpPortal = document.getElementsByTagName("sb-resp-popup-content")[0];
    popUpPortal.classList.add("ipad-detection-popup");
};
//# sourceMappingURL=helpers.js.map